import { registerPlugin } from '@capacitor/core';

import type { QSenseHubControlPlugin } from '@/plugins/QSenseHubControl/definitions';

const QSenseHubControl = registerPlugin<QSenseHubControlPlugin>('QSenseHubControl', {
  web: () => import('./web').then((m) => new m.QSenseHubControlWeb()),
});

export * from './definitions';
export { QSenseHubControl };
export * from './QSenseHubHook';
